import { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { HelpCircle } from 'lucide-react'
import styles from './HelpModal.module.css'

function SectionBody({ body }) {
  if (Array.isArray(body)) {
    return (
      <ul className={styles.list}>
        {body.map((item, i) => <li key={i}>{item}</li>)}
      </ul>
    )
  }
  return <p className={styles.paragraph}>{body}</p>
}

export default function HelpModal({ isOpen, onClose, icon: Icon, content, onAskAI }) {
  useEffect(() => {
    if (!isOpen) return
    const handler = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [isOpen, onClose])

  if (!isOpen || !content) return null

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.titleRow}>
            <span className={styles.titleIcon}>
              {Icon ? <Icon size={18} strokeWidth={2} /> : <HelpCircle size={18} strokeWidth={2} />}
            </span>
            <div>
              <div className={styles.title}>How to use {content.title}</div>
              {content.intro && <div className={styles.sub}>{content.intro}</div>}
            </div>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div className={styles.body}>
          {content.sections.map((section, i) => (
            <section key={i} className={styles.section}>
              <div className={styles.sectionHeading}>{section.heading}</div>
              <SectionBody body={section.body} />
            </section>
          ))}
        </div>

        {content.suggestedPrompt && (
          <div className={styles.footer}>
            <div className={styles.footerLabel}>Try asking the AI</div>
            <div className={styles.footerRow}>
              <div className={styles.promptText}>&ldquo;{content.suggestedPrompt}&rdquo;</div>
              <button className={styles.askBtn} onClick={() => onAskAI(content.suggestedPrompt)}>
                Ask the AI →
              </button>
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body
  )
}
